import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { axiosInstance } from "../../config/axios";

export interface IGetMerchantValueDatedPaymentDetailsRequest {
  page: number;
  size: number;
  filters: Array<any>
}

async function GetMerchantValueDatedPaymentDetails(
  data: IGetMerchantValueDatedPaymentDetailsRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Reconciliation/GetValueDatePaymentDetails", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantValueDatedPaymentDetails() {
  return useMutation<any, Error, IGetMerchantValueDatedPaymentDetailsRequest>((variables) =>
    GetMerchantValueDatedPaymentDetails(variables)
  );
}
